import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["nps"],
                headline:
                    "How likely is it that you would recommend this company to a friend or colleague?",
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Overall, how satisfied or dissatisfied are you with our company?",
                choices: [
                    generateNewChoice("Very satisfied"),
                    generateNewChoice("Somewhat satisfied"),
                    generateNewChoice("Neither satisfied nor dissatisfied"),
                    generateNewChoice("Somewhat dissatisfied"),
                    generateNewChoice("Very dissatisfied"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceMulti"],
                headline:
                    "Which of the following words would you use to describe our products? Select all that apply.",
                choices: [
                    generateNewChoice("Reliable"),
                    generateNewChoice("High quality"),
                    generateNewChoice("Useful"),
                    generateNewChoice("Unique"),
                    generateNewChoice("Good value for money"),
                    generateNewChoice("Overpriced"),
                    generateNewChoice("Impractical"),
                    generateNewChoice("Ineffective"),
                    generateNewChoice("Poor quality"),
                    generateNewChoice("Unreliable"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How well do our products meet your needs?",
                choices: [
                    generateNewChoice("Extremely well"),
                    generateNewChoice("Very well"),
                    generateNewChoice("Somewhat well"),
                    generateNewChoice("Not so well"),
                    generateNewChoice("Not at all well"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How would you rate the quality of the product?",
                choices: [
                    generateNewChoice("Very high quality"),
                    generateNewChoice("High quality"),
                    generateNewChoice("Neither high nor low quality"),
                    generateNewChoice("Low quality"),
                    generateNewChoice("Very low quality"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How would you rate the value for money of the product?",
                choices: [
                    generateNewChoice("Excellent"),
                    generateNewChoice("Above average"),
                    generateNewChoice("Average"),
                    generateNewChoice("Below average"),
                    generateNewChoice("Poor"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How responsive have we been to your questions about our services?",
                choices: [
                    generateNewChoice("Extremely responsive"),
                    generateNewChoice("Very responsive"),
                    generateNewChoice("Somewhat responsive"),
                    generateNewChoice("Not so responsive"),
                    generateNewChoice("Not at all responsive"),
                    generateNewChoice("Not applicable"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How long have you been a customer of our company?",
                choices: [
                    generateNewChoice("This is my first purchase"),
                    generateNewChoice("Less than six months"),
                    generateNewChoice("Six months to a year"),
                    generateNewChoice("1 - 2 years"),
                    generateNewChoice("3 or more years"),
                    generateNewChoice("I haven't made a purchase yet"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How likely are you to purchase any of our products again?",
                choices: [
                    generateNewChoice("Extremely likely"),
                    generateNewChoice("Very likely"),
                    generateNewChoice("Somewhat likely"),
                    generateNewChoice("Not so likely"),
                    generateNewChoice("Not at all likely"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "Do you have any other comments, questions, or concerns?",
                longAnswer: true,
            },
        ],
    },
];

export const customerSatisfactionSurveyTemplate = generateSurveyTemplate({
    name: "Customer Satisfaction Survey",
    pages,
});
